define("shared/utils/has-linkinbio-feed-block", ["exports", "shared/utils/constants/linkinbio-block-types"], function (_exports, _linkinbioBlockTypes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.hasLinkinbioFeedBlock = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/constants/linkinbio-block-types"eaimeta@70e063a35619d71f
  /**
   * Given a Linkinbio page and Social profile, returns if the page has a feed block for the given social profile
   */
  const hasLinkinbioFeedBlock = (linkinbioPage, socialProfile) => {
    if (!linkinbioPage) {
      return false;
    }
    const feedBlocks = linkinbioPage.get('linkinbioBlocks')?.filterBy('blockType', _linkinbioBlockTypes.default.Feed) || [];
    return feedBlocks.some(block => block.blockData.enabled && block.connectedObjectId === socialProfile?.id);
  };
  _exports.hasLinkinbioFeedBlock = hasLinkinbioFeedBlock;
});